import React from 'react';
import { Box } from '@mui/material';
import HeroSection from '../components/HeroSection';
import InteractiveViewers from '../components/InteractiveViewers';
import AboutUs from '../components/AboutUs';
import Project from '../components/Project';
import Comments from '../components/Comments';

const HomePage = () => {
  return (
    <Box>
      <HeroSection />
      <Project />
      <InteractiveViewers />
      <Comments/>
      <AboutUs />
    </Box>
  );
};

export default HomePage;